/* eslint-disable react-hooks/exhaustive-deps */
import clsx from "clsx";
import { HeaderUserMenu } from "../../../partials";
import { useIntl } from "react-intl";
import { useStyleContext } from "../../../helpers/StyleContext";
import { ProfileImageContext } from "../../../helpers/ProfileImageContext";
import { LogoImageContext } from "../../../helpers/LogoImageContext";
import {
  MouseEvent,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import axios, { AxiosRequestHeaders } from "axios";
import { getAuth, useAuth } from "../../../../app/modules/auth";
import { useNavbar } from "../../../contexts/NavbarContext";
import { io } from "socket.io-client";
import { ModalCreateVisitor } from "../modal-create-user/ModalCreateVisitor";
import { Link, useLocation } from "react-router-dom";
import UserListByCategoryModal from "../../../partials/modals/users-by-category/userListByCategoryModal";
import { AbrirCaixaModal } from "../../../../app/modules/caixa-financeiro/components/AbrirCaixaModal";
import { FecharCaixaModal } from "../../../../app/modules/caixa-financeiro/components/FecharCaixaModal";
import {
  CaixaSession,
  fetchOpenSession,
} from "../../../../app/modules/caixa-financeiro/utils/caixa.api";
import { useCanOpenCaixa } from "../../../../app/modules/caixa-financeiro/hooks/useCanOpenCaixa";
import { useNovoPedidoModal } from "../../../../app/modules/cardapio/context/NovoPedidoContext";
import { TopbarPagarModal } from "../../../../app/modules/cardapio/components/TopbarPagarModal";

const itemClass = "ms-1 ms-lg-3";
const userAvatarClass = "symbol-35px symbol-md-40px";

const Navbar = () => {
  const { groupValues, updateGroupValues } = useNavbar();
  const { styleState } = useStyleContext();
  const { profileImageState } = useContext(ProfileImageContext);
  const { logoImageState } = useContext(LogoImageContext);
  const [showModal, setShowModal] = useState(false);
  const [selectedItemModal, setSelectedItemModal] = useState("");
  const [caixaSession, setCaixaSession] = useState<CaixaSession | null>(null);
  const [showAbrirCaixaModal, setShowAbrirCaixaModal] = useState(false);
  const [showFecharCaixaModal, setShowFecharCaixaModal] = useState(false);
  const [showPagarModal, setShowPagarModal] = useState(false);
  const location = useLocation();
  const intl = useIntl();
  const { openNovoPedido } = useNovoPedidoModal();
  const canOpenCaixa = useCanOpenCaixa();
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiToken = getAuth();
  const token = apiToken?.api_token;
  const module = `topbar`;

  const isCaixaAberto = caixaSession?.status === "aberto";
  const showCaixaButton = isCaixaAberto || canOpenCaixa;

  const handleNovoPedidoClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    openNovoPedido();
  };

  const handlePagarClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setShowPagarModal(true);
  };

  const refreshCaixaSession = useCallback(() => {
    fetchOpenSession()
      .then((session) =>
        setCaixaSession(session?.status === "aberto" ? session : null),
      )
      .catch(() => setCaixaSession(null));
  }, []);

  const handleShowModal = (category: string) => {
    setSelectedItemModal(category);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleCaixaClick = (event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (isCaixaAberto) {
      setShowFecharCaixaModal(true);
      return;
    }
    if (!canOpenCaixa) return;
    setShowAbrirCaixaModal(true);
  };

  const findHeaders: AxiosRequestHeaders = {
    Authorization: `Bearer ${token}`,
    operation: `${module}/find`,
  };

  const { currentUser } = useAuth();

  useEffect(() => {
    refreshCaixaSession();
    const onSessionChanged = () => refreshCaixaSession();
    window.addEventListener("caixa:session-changed", onSessionChanged);
    return () =>
      window.removeEventListener("caixa:session-changed", onSessionChanged);
  }, [refreshCaixaSession, location.pathname]);

  useEffect(() => {
    const socket = io(apiUrl ?? "");

    if (!module) {
      return;
    }

    const loadData = async (module: string, headers: AxiosRequestHeaders) => {
      try {
        const response = await axios.get(`${apiUrl}/${module}`, {
          headers,
        });

        updateGroupValues(response.data);

        return response;
      } catch (error) {
        // showErrorMessage();
        // error?.response?.data?.error?.statusCode,
        // error?.response?.data?.error?.message
        // if (error?.response?.data?.error?.statusCode === 403) {
        //   navigate("/");
        // }
      }
    };

    loadData(module, findHeaders);

    const handleTopbarNotification = () => {
      loadData(module, findHeaders).then((response: any) => {
        !!response?.data && updateGroupValues(response?.data);
      });
    };

    socket.on(
      `topbarNotification${currentUser?._id_company}`,
      handleTopbarNotification,
    );

    return () => {
      socket.off(
        `topbarNotification${currentUser?._id_company}`,
        handleTopbarNotification,
      );

      socket.disconnect();
    };
  }, [apiUrl, module, token, currentUser]);

  return (
    <div className="app-navbar align-items-center w-100 gap-responsive" style={{ backgroundColor: styleState?.header_background_color }} >
      <div className="col d-flex flex-column text-center" title={intl.formatMessage({ id: "MENU.HEADER.GROUPS.REGISTERED" })} >
        <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body text-hover-primary" key={"registeredUsers"} to="#" onClick={(event) => { event.preventDefault(); handleShowModal("registeredUsers"); }} >
          <i className="fas fa-users mb-1"></i>
          <label>{groupValues.registeredUsersCount}</label>
        </Link>
      </div>
      <div className="col d-flex flex-column text-center" title={intl.formatMessage({ id: "MENU.HEADER.GROUPS.VISITOR" })} >
        <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body text-hover-primary" key={"registeredUsers"} to="#" onClick={(event) => { event.preventDefault(); handleShowModal("registeredUsers"); }} >
          <i className="fas fa-users mb-1"></i>
          {/* <label>{groupValues.registeredUsersCount}</label> */}
          <label>0</label>
        </Link>
      </div>
      <div className="col d-flex flex-column text-center d-none d-sm-flex" title={intl.formatMessage({ id: "MENU.HEADER.GROUPS.IN_DAY" })} >
        <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body " key={"complianceUsers"} to="#" onClick={(event) => { event.preventDefault(); handleShowModal("complianceUsers"); }} >
          <i className="fas fa-users text-success"></i>
          <label>{groupValues.complianceUsersCount}</label>
        </Link>
      </div>

      <div className="col d-flex flex-column text-center d-none d-sm-flex" title={intl.formatMessage({ id: "MENU.HEADER.GROUPS.OVERDUE_PARTNERS", })} >
        <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body" key={"nonComplianceUsers"} to="#" onClick={(event) => { event.preventDefault(); handleShowModal("nonComplianceUsers"); }} >
          <i className="fas fa-users text-danger"></i>
          <label>{groupValues.nonComplianceUsersCount}</label>
        </Link>
      </div>
      <div className="col d-flex flex-column text-center d-none d-sm-flex" title={intl.formatMessage({ id: "MENU.HEADER.GROUPS.BANNED", })} >
        <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body" key={"bannedUsers"} to="#" onClick={(event) => { event.preventDefault(); handleShowModal("bannedUsers"); }} >
          <i className="fas fa-users" style={{ color: "purple" }}></i>
          <label>{groupValues.bannedUsersCount}</label>
        </Link>
      </div>
      <div className="col d-flex flex-column text-center" style={{ zIndex: 1 }}>
        <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body mt-10" key={"logo-company"} to="#" onClick={(event) => { event.preventDefault(); }} >
          <img id="logoCompanies" src={logoImageState.company_logo} alt="" data-bs-toggle="collapse" data-bs-target="#collapseExample" />
        </Link>
      </div>
      <div className="col d-flex flex-column text-center d-none d-sm-flex" title={intl.formatMessage({ id: "MENU.HEADER.GROUPS.PRESENT", })} >
        <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body" key={"usersOnline"} to="#" onClick={(event) => { event.preventDefault(); handleShowModal("usersOnline"); }} >
          <i className="fas fa-users" style={{ color: "#00FF5F" }}></i>
          <label>{groupValues.usersCount}</label>
        </Link>
      </div>
      <div className="col d-flex flex-column text-center d-none d-sm-flex" title={intl.formatMessage({ id: "MENU.HEADER.GROUPS.VISITORS", })} >
        <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body" key={"visitorsOnline"} to="#" onClick={(event) => { event.preventDefault(); handleShowModal("visitorsOnline"); }} >
          <i className="fas fa-users text-body"></i>
          <label>{groupValues.visitorsCount}</label>
        </Link>
      </div>
      <div className="col d-flex flex-column text-center" title={intl.formatMessage({ id: "MENU.HEADER.GROUPS.TOTAL_USERS_ON", })} >
        <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body" key={"allUsersOnline"} to="#" onClick={(event) => { event.preventDefault(); handleShowModal("allUsersOnline"); }} >
          <i className="fas fa-users" style={{ color: "purple" }}></i>
          <label>{groupValues.totalUsersCount}</label>
        </Link>
      </div>

      {/* <div className="col d-flex flex-column text-center"> */}
        <ModalCreateVisitor />
      {/* </div> */}
      {showCaixaButton && (
        <div className={clsx( "col d-flex flex-column text-center rounded cursor-pointer ps-0 ms-0 ms-n7 me-2", isCaixaAberto ? "bg-danger" : "bg-success", )} >
          <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body ps-2 pe-2" key={"caixa-topbar"} to="#" onClick={handleCaixaClick} >
              <i className={clsx( "fas fa-cash-register", isCaixaAberto ? "text-success" : "text-danger", )} />
              <label style={{ fontSize: "9px" }}>
                {isCaixaAberto ? "Fechar Caixa" : "Abrir Caixa"}
              </label>
            </Link>
        </div>
      )}

      {/* <div className="col d-flex flex-column align-items-left">
        <div className="bg-success rounded cursor-pointer ps-2 pe-2">
          <Link style={{ textDecoration: "none" }} className="d-flex flex-column align-items-center text-body" key={"allUsersOnline"} to="#" onClick={handleCaixaClick} >
            <i className={clsx( "fas fa-cash-register", isCaixaAberto ? "text-success" : "text-danger", )} />
            <label style={{ fontSize: "9px" }}>
              {isCaixaAberto ? "Fechar Caixa" : "Abrir Caixa"}
            </label>
          </Link>
        </div>
      </div> */}

      <div className="d-flex position-absolute align-items-center me-3" style={{ right: 0 }} >
        <div className={clsx("app-navbar-item", itemClass)}>
          <div className={clsx("cursor-pointer symbol", userAvatarClass)} data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end" >
            <img src={profileImageState.profile_image} alt="" style={{ border: `3px solid ${ profileImageState?.braceletColor ? profileImageState?.braceletColor : "not defined" }`, width: "4em", height: "4em", borderRadius: "4em", }} />
          </div>
          <HeaderUserMenu />
        </div>
        <UserListByCategoryModal showModal={showModal} setShowModal={setShowModal} selectedItemModal={selectedItemModal} handleClose={handleClose} />
      </div>

      {canOpenCaixa && (
        <AbrirCaixaModal
          show={showAbrirCaixaModal}
          onClose={() => setShowAbrirCaixaModal(false)}
          onOpened={() => {
            refreshCaixaSession();
            window.dispatchEvent(new Event("caixa:session-changed"));
          }}
        />
      )}
      <FecharCaixaModal
        show={showFecharCaixaModal}
        onClose={() => setShowFecharCaixaModal(false)}
        onClosed={() => {
          refreshCaixaSession();
          window.dispatchEvent(new Event("caixa:session-changed"));
        }}
      />
      <TopbarPagarModal show={showPagarModal} onClose={() => setShowPagarModal(false)} />
    </div>
  );
};

export { Navbar };
